import { FormControl, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { AnimatePresence, motion } from "motion/react";
import { useMemo } from "react";
import { TbCalendarDot } from "react-icons/tb";

import useAuth from "@/providers/hooks/useAuth";
import { useGetDailyStatusCurrentShift } from "@/requests/daily-status.queries";
import { useShiftActions, useShiftShowFloatingActionButton } from "@/stores/use-shift";
import { UserType } from "@/types/user.types";

import LandingShiftChoose from "./LandingShiftChoose";
import LandingShiftInfo from "./LandingShiftInfo";

const iconVariants = {
    initial: { opacity: 0, rotateY: 90 },
    animate: { opacity: 1, rotateY: 0 },
};
const textVariants = {
    initial: { opacity: 0, rotateX: 90 },
    animate: { opacity: 1, rotateX: 0 },
};

function LandingShiftComp() {
    const { data, isPending } = useGetDailyStatusCurrentShift();
    const { userData } = useAuth();

    const currentShift = useMemo(() => (data ? data.shift || undefined : undefined), [data]);
    const userType = useMemo(() => (data ? data.userType : false), [data]);

    return (
        userData &&
        userType &&
        userType !== UserType.DRIVER &&
        !isPending && (
            <div className="rounded shadow   w-full mt-8 flex flex-col col-span-full">
                <div className="flex  items-center p-3 gap-3  bg-gray-50">
                    <div className="flex justify-center">
                        <motion.div
                            variants={iconVariants}
                            initial="initial"
                            animate="animate"
                            transition={{ delay: 0.2, duration: 0.4 }}
                            className="mx-auto flex w-14 h-14  bg-blue-100 text-blue-800 shrink-0 items-center justify-center rounded-full cursor-pointer"
                        >
                            <TbCalendarDot fontSize={25} />
                        </motion.div>
                    </div>
                    <motion.div
                        variants={textVariants}
                        initial="initial"
                        animate="animate"
                        transition={{ delay: 0.2, duration: 0.4 }}
                        className="font-semibold text-lg "
                    >
                        Mesai İşlemleri
                        <div className=" text-gray-500 text-sm  font-normal">
                            Mesai işlemlerinizi bu ekrandan yapabilirsiniz.
                        </div>
                    </motion.div>
                </div>
                <div className="  pb-3 px-3 mt-2 w-full">
                    <AnimatePresence mode="sync">
                        {currentShift ? <LandingShiftInfo currentShift={currentShift} /> : <LandingShiftChoose />}
                    </AnimatePresence>
                </div>
                <FloatingActionButtonStatus />
            </div>
        )
    );
}

function FloatingActionButtonStatus() {
    const shiftShowFloatingActionButton = useShiftShowFloatingActionButton();
    const { updateShowFloatingActionButton } = useShiftActions();
    return (
        <div className="px-3 bg-gray-50">
            <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                    <FormControlLabel
                        value="end"
                        control={
                            <Switch
                                color="primary"
                                checked={shiftShowFloatingActionButton}
                                onChange={(_e, checked) => updateShowFloatingActionButton(checked)}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        }
                        label="Mesai işlemleri için sağ alt kısımda buton göster"
                        labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>
        </div>
    );
}

export default LandingShiftComp;
